import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import TextArea from "../../components/elements/TextArea";
import Button from "../../components/elements/Button";
import InputField from "../../components/elements/InputField";
import {ADMIN_API_BASE} from "../../utils/apiConfig";

const AdminSendNotification = () => {

    const [title, setTitle] = useState('');
    const [notificationBody, setNotificationBody] = useState('');

    const handleOnChangeBody = (e) => {
        setNotificationBody(prevState => e.target.value);
    }

    const handleOnChangeTitle = (e) => {
        setTitle(prevState => e.target.value);
    }

    const handleButtonClick = async () => {
        try {
            const token = await getCsrfToken();

            let response = await axios.post(`${ADMIN_API_BASE}/notification/`, {
                    title: title,
                    body: notificationBody,
                },
                {
                    headers: {
                        'csrf-token': token,
                    },
                    withCredentials: true
                });

            if (response.data.success) {
                alert("Message sent successfully!");
            } else {
                alert("Message was not sent.!");
            }

        } catch
            (e) {
            console.log(e);
        }
    }


    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include",
        });

        const data = await response.json();
        return data.csrfToken;
    };

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='ارسال نوتیفیکیشن'/>
                        <div className='w-full flex gap-4 py-3 px-10 flex-1 my-10'>
                            <form className='w-full flex-col flex gap-5 px-8 py-5'
                                  onSubmit={(e) => e.preventDefault()}>
                                <InputField type='text' title='تیتر' onChange={handleOnChangeTitle}
                                            value={title}/>
                                <TextArea title='متن نوتیفیکیشن' value={notificationBody}
                                          onChange={handleOnChangeBody}/>
                                <Button onClick={handleButtonClick}>
                                    <span>ارسال</span>
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminSendNotification;
